import Presentation from "./presentation";

const Component = () => {

	return ( <Presentation /> );
};

export default Component;